
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $lyoVb = parcelRequire("lyoVb");

var $jPe3p = parcelRequire("jPe3p");
var $386346660f3e79ca$exports = {};
/**
 * k-d Tree JavaScript - V 1.01
 *
 * https://github.com/ubilabs/kd-tree-javascript
 *
 * @author Mircea Pricop <pricop@ubilabs.net>, 2012
 * @author Martin Kleppe <kleppe@ubilabs.net>, 2012
 * @author Ubilabs http://ubilabs.net, 2012
 * @license MIT License <http://www.opensource.org/licenses/mit-license.php>
 */ !function(t, n) {
    "function" == typeof define && define.amd ? define([
        "exports"
    ], n) : n($386346660f3e79ca$exports);
}($386346660f3e79ca$exports, function(t) {
    function n(t, n, o) {
        this.obj = t, this.left = null, this.right = null, this.parent = o, this.dimension = n;
    }
    function o(t) {
        this.content = [], this.scoreFunction = t;
    }
    o.prototype = {
        push: function(t) {
            this.content.push(t), this.bubbleUp(this.content.length - 1);
        },
        pop: function() {
            var t = this.content[0], n = this.content.pop();
            return this.content.length > 0 && (this.content[0] = n, this.sinkDown(0)), t;
        },
        peek: function() {
            return this.content[0];
        },
        remove: function(t) {
            for(var n = this.content.length, o = 0; o < n; o++)if (this.content[o] == t) {
                var i = this.content.pop();
                return void (o != n - 1 && (this.content[o] = i, this.scoreFunction(i) < this.scoreFunction(t) ? this.bubbleUp(o) : this.sinkDown(o)));
            }
            throw new Error("Node not found.");
        },
        size: function() {
            return this.content.length;
        },
        bubbleUp: function(t) {
            for(var n = this.content[t]; t > 0;){
                var o = Math.floor((t + 1) / 2) - 1, i = this.content[o];
                if (!(this.scoreFunction(n) < this.scoreFunction(i))) break;
                this.content[o] = n, this.content[t] = i, t = o;
            }
        },
        sinkDown: function(t) {
            for(var n = this.content.length, o = this.content[t], i = this.scoreFunction(o);;){
                var e = 2 * (t + 1), r = e - 1, l = null;
                if (r < n) {
                    var u = this.content[r], h = this.scoreFunction(u);
                    h < i && (l = r);
                }
                if (e < n) {
                    var s = this.content[e];
                    this.scoreFunction(s) < (null == l ? i : h) && (l = e);
                }
                if (null == l) break;
                this.content[t] = this.content[l], this.content[l] = o, t = l;
            }
        }
    }, t.kdTree = function(t, i, e) {
        function r(t, o, i) {
            var l, u, h = o % e.length;
            return 0 === t.length ? null : 1 === t.length ? new n(t[0], h, i) : (t.sort(function(t, n) {
                return t[e[h]] - n[e[h]];
            }), l = Math.floor(t.length / 2), u = new n(t[l], h, i), u.left = r(t.slice(0, l), o + 1, u), u.right = r(t.slice(l + 1), o + 1, u), u);
        }
        var l = this;
        Array.isArray(t) ? this.root = r(t, 0, null) : function(t) {
            function n(t) {
                t.left && (t.left.parent = t, n(t.left)), t.right && (t.right.parent = t, n(t.right));
            }
            l.root = t, n(l.root);
        }(t), this.toJSON = function(t) {
            t || (t = this.root);
            var o = new n(t.obj, t.dimension, null);
            return t.left && (o.left = l.toJSON(t.left)), t.right && (o.right = l.toJSON(t.right)), o;
        }, this.insert = function(t) {
            function o(n, i) {
                if (null === n) return i;
                var r = e[n.dimension];
                return t[r] < n.obj[r] ? o(n.left, n) : o(n.right, n);
            }
            var i, r, l = o(this.root, null);
            null !== l ? (i = new n(t, (l.dimension + 1) % e.length, l), r = e[l.dimension], t[r] < l.obj[r] ? l.left = i : l.right = i) : this.root = new n(t, 0, null);
        }, this.remove = function(t) {
            function n(o) {
                if (null === o) return null;
                if (o.obj === t) return o;
                var i = e[o.dimension];
                return t[i] < o.obj[i] ? n(o.left, o) : n(o.right, o);
            }
            function o(t) {
                function n(t, o) {
                    var i, r, l, u, h;
                    return null === t ? null : (i = e[o], t.dimension === o ? null !== t.left ? n(t.left, o) : t : (r = t.obj[i], l = n(t.left, o), u = n(t.right, o), h = t, null !== l && l.obj[i] < r && (h = l), null !== u && u.obj[i] < h.obj[i] && (h = u), h));
                }
                var i, r, u;
                if (null === t.left && null === t.right) return null === t.parent ? void (l.root = null) : (u = e[t.parent.dimension], void (t.obj[u] < t.parent.obj[u] ? t.parent.left = null : t.parent.right = null));
                null !== t.right ? (r = (i = n(t.right, t.dimension)).obj, o(i), t.obj = r) : (r = (i = n(t.left, t.dimension)).obj, o(i), t.right = t.left, t.left = null, t.obj = r);
            }
            var i;
            null !== (i = n(l.root)) && o(i);
        }, this.nearest = function(t, n, r) {
            function u(o) {
                function r(t, o) {
                    f.push([
                        t,
                        o
                    ]), f.size() > n && f.pop();
                }
                var l, h, s, c, a = e[o.dimension], g = i(t, o.obj), p = {};
                for(c = 0; c < e.length; c += 1)c === o.dimension ? p[e[c]] = t[e[c]] : p[e[c]] = o.obj[e[c]];
                h = i(p, o.obj), null !== o.right || null !== o.left ? (u(l = null === o.right ? o.left : null === o.left ? o.right : t[a] < o.obj[a] ? o.left : o.right), (f.size() < n || g < f.peek()[1]) && r(o, g), (f.size() < n || Math.abs(h) < f.peek()[1]) && null !== (s = l === o.left ? o.right : o.left) && u(s)) : (f.size() < n || g < f.peek()[1]) && r(o, g);
            }
            var h, s, f;
            if (f = new o(function(t) {
                return -t[1];
            }), r) for(h = 0; h < n; h += 1)f.push([
                null,
                r
            ]);
            for(l.root && u(l.root), s = [], h = 0; h < Math.min(n, f.content.length); h += 1)f.content[h][0] && s.push([
                f.content[h][0].obj,
                f.content[h][1]
            ]);
            return s;
        }, this.balanceFactor = function() {
            function t(n) {
                return null === n ? 0 : Math.max(t(n.left), t(n.right)) + 1;
            }
            function n(t) {
                return null === t ? 0 : n(t.left) + n(t.right) + 1;
            }
            return t(l.root) / (Math.log(n(l.root)) / Math.log(2));
        };
    }, t.BinaryHeap = o;
});


function $075a852226c2c23c$export$de27182ff8187d6c() {
    (0, $lyoVb.setupCommon)();
    textSize((0, $lyoVb.w)(0.015));
}
function $075a852226c2c23c$var$boundingBox(points) {
    let xmin = Math.min(...points.map((p)=>p[0])) - 0.01;
    let ymin = Math.min(...points.map((p)=>p[1])) - 0.01;
    let xmax = Math.max(...points.map((p)=>p[0])) + 0.01;
    let ymax = Math.max(...points.map((p)=>p[1])) + 0.01;
    return [
        xmin,
        ymin,
        xmax,
        ymax
    ];
}
const $075a852226c2c23c$var$distanceFn = function(a, b) {
    return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2);
};
const $075a852226c2c23c$var$veinStep = 0.0015;
const $075a852226c2c23c$var$nodes = [
    [
        0.5,
        0.925
    ]
];
const $075a852226c2c23c$var$food = [];
const $075a852226c2c23c$var$childlessNodes = new Set([
    0
]);
const $075a852226c2c23c$var$edges = new Map();
const $075a852226c2c23c$var$edgeGraph = new Map();
let $075a852226c2c23c$var$largest = 1;
function $075a852226c2c23c$export$e529deb2bfd496dc() {
    (0, $lyoVb.drawCommon)();
    background(5);
    translate((0, $lyoVb.w)(0.4), (0, $lyoVb.h)(-0.1));
    rotate(QUARTER_PI);
    noFill();
    stroke(0, 0, 95, 0.05);
    strokeWeight((0, $lyoVb.w)(0.001));
    rect((0, $lyoVb.w)(-0.5), (0, $lyoVb.h)(-0.5), (0, $lyoVb.w)(1), (0, $lyoVb.h)(1));
    rect((0, $lyoVb.w)(-0.25), (0, $lyoVb.h)(-0.25), (0, $lyoVb.w)(0.5), (0, $lyoVb.h)(0.5));
    rect((0, $lyoVb.w)(0.25), (0, $lyoVb.h)(0.85), (0, $lyoVb.w)(0.75), (0, $lyoVb.h)(0.75));
    rect((0, $lyoVb.w)(0.75), (0, $lyoVb.h)(0.35), (0, $lyoVb.w)(0.75), (0, $lyoVb.h)(0.75));
    resetMatrix();
    const oldNodesTree = new (0, (/*@__PURE__*/$parcel$interopDefault($386346660f3e79ca$exports))).kdTree($075a852226c2c23c$var$nodes.map(([x, y], idx)=>({
            x: x,
            y: y,
            idx: idx
        })), $075a852226c2c23c$var$distanceFn, [
        "x",
        "y"
    ]);
    const enoughFood = $075a852226c2c23c$var$food.length > 50 || $075a852226c2c23c$var$nodes.length > 6000;
    if (!enoughFood) {
        const bb = $075a852226c2c23c$var$boundingBox($075a852226c2c23c$var$nodes);
        const dy = bb[3] - bb[1];
        const vr = 3.0;
        const vs = 0.8;
        const [vx, vy] = $075a852226c2c23c$var$nodes[0];
        const vscale = 0.031 + dy * 0.14;
        const vbot = sqrt(vs * vs * vr * vr) / vs;
        const vtop = -vbot;
        for(let i = 0; i < 10; i++){
            const y = Math.random() * 0.95 * (vbot - vtop) - vbot + 0.05;
            const bound = vs * (sqrt(sq(vs * vr) - sq(vs * y)) - 0.5) * vscale;
            const foodX = Math.random() * 2 * bound - bound + vx;
            const foodY = y * vscale + (vy - vbot * vscale);
            if (foodX > 0 && foodX < 1 && foodY > 0 && foodY < 1) {
                if (oldNodesTree.nearest({
                    x: foodX,
                    y: foodY
                }, 1, 0.000025).length == 0) $075a852226c2c23c$var$food.push([
                    foodX,
                    foodY
                ]);
            }
        }
    }
    const nodeInfluences = {};
    $075a852226c2c23c$var$food.forEach(([foodX, foodY], foodIdx)=>{
        const nodeIdx = oldNodesTree.nearest({
            x: foodX,
            y: foodY
        }, 1)[0][0].idx;
        const foodVec = createVector($075a852226c2c23c$var$food[foodIdx][0], $075a852226c2c23c$var$food[foodIdx][1]);
        const nodeVec = createVector($075a852226c2c23c$var$nodes[nodeIdx][0], $075a852226c2c23c$var$nodes[nodeIdx][1]);
        const direction = (0, (/*@__PURE__*/$parcel$interopDefault($jPe3p))).Vector.sub(foodVec, nodeVec).normalize();
        if (nodeInfluences[nodeIdx]) nodeInfluences[nodeIdx].add(direction);
        else nodeInfluences[nodeIdx] = direction;
    });
    Object.keys(nodeInfluences).forEach((k)=>{
        nodeInfluences[k].normalize();
    });
    const newNodes = [];
    Object.keys(nodeInfluences).forEach((k)=>{
        const node = $075a852226c2c23c$var$nodes[k];
        const influence = nodeInfluences[k];
        const newNode = [
            node[0] + influence.x * $075a852226c2c23c$var$veinStep,
            node[1] + influence.y * $075a852226c2c23c$var$veinStep
        ];
        const newIdx = $075a852226c2c23c$var$nodes.push(newNode) - 1;
        newNodes.push(newNode);
        const parentIdx = Number(k);
        $075a852226c2c23c$var$childlessNodes.add(newIdx);
        const parentWasChildless = $075a852226c2c23c$var$childlessNodes.delete(parentIdx);
        $075a852226c2c23c$var$edgeGraph.set(newIdx, parentIdx);
        $075a852226c2c23c$var$edges.set(`${newIdx}-${parentIdx}`, 1);
        if (!parentWasChildless) {
            let currentIdx = parentIdx;
            while(currentIdx !== 0){
                const currentParentIdx = $075a852226c2c23c$var$edgeGraph.get(currentIdx);
                const edgeKey = `${currentIdx}-${currentParentIdx}`;
                const weight = $075a852226c2c23c$var$edges.get(edgeKey);
                $075a852226c2c23c$var$edges.set(edgeKey, weight + 1);
                currentIdx = currentParentIdx;
                $075a852226c2c23c$var$largest = Math.max($075a852226c2c23c$var$largest, weight);
            }
        }
    });
    // remove food if vein is in neighborhood
    newNodes.forEach(([nodeX, nodeY])=>{
        $075a852226c2c23c$var$food.forEach(([foodX, foodY], idx)=>{
            const d = dist(foodX, foodY, nodeX, nodeY);
            if (d < 0.025) $075a852226c2c23c$var$food.splice(idx, 1);
        });
    });
    $075a852226c2c23c$var$edges.forEach((weight, key)=>{
        const [a, b] = key.split("-").map(Number);
        const [x1, y1] = $075a852226c2c23c$var$nodes[a];
        const n = sqrt(weight / $075a852226c2c23c$var$largest);
        strokeWeight((0, $lyoVb.w)(0.0015));
        stroke(noise(frameCount * 0.01, y1, n * 5) * 100 + 150, 60 - 30 * n, 60 + 20 * n, 0.25);
        ellipse((0, $lyoVb.w)(x1), (0, $lyoVb.h)(y1), (0, $lyoVb.w)(n * 0.1));
    });
}



var $gPx2I = parcelRequire("gPx2I");
parcelRequire("d3dEA");
const $af5179ab494d7e33$var$source = "import {\n  easeInOutSine,\n  smoothstep,\n  clamp,\n  w, h,\n  frame,\n  frameN,\n  setFrameN,\n  getCanvasSize,\n  setupCommon,\n  drawCommon,\n  make,\n} from '../js/common.js';\nimport p5 from 'p5';\nimport kdTree from './kdTree.min.js';\n\nexport function setup() {\n	setupCommon();\n	textSize(w(0.015));\n}\n\nfunction boundingBox(points) {\n	let xmin = Math.min(...points.map(p => p[0])) - 0.01;\n	let ymin = Math.min(...points.map(p => p[1])) - 0.01;\n\n	let xmax = Math.max(...points.map(p => p[0])) + 0.01;\n	let ymax = Math.max(...points.map(p => p[1])) + 0.01;\n\n	return [xmin, ymin, xmax, ymax];\n}\n\nconst distanceFn = function(a, b) {\n	return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2);\n}\n\nconst veinStep = 0.0015;\n\nconst nodes = [[0.5, 0.925]];\nconst food = [];\nconst childlessNodes = new Set([0]);\nconst edges = new Map();\nconst edgeGraph = new Map();\nlet largest = 1;\nexport function draw() {\n	drawCommon();\n\n	background(5);\n	translate(w(0.4), h(-0.1));\n	rotate(QUARTER_PI);\n	noFill();\n	stroke(0, 0, 95, 0.05);\n	strokeWeight(w(0.001));\n	rect(w(-0.5), h(-0.5), w(1), h(1));\n	rect(w(-0.25), h(-0.25), w(0.5), h(0.5));\n	rect(w(0.25), h(0.85), w(0.75), h(0.75));\n	rect(w(0.75), h(0.35), w(0.75), h(0.75));\n	resetMatrix();\n\n\n	const oldNodesTree = new kdTree.kdTree(\n		nodes.map(([x, y], idx) => ({ x, y, idx })),\n		distanceFn,\n		['x', 'y']\n	);\n\n	const enoughFood = food.length > 50 || nodes.length > 6000;\n	if (!enoughFood) {\n		const bb = boundingBox(nodes);\n		const dy = bb[3] - bb[1];\n\n		const vr = 3.0;\n		const vs = 0.8;\n		const [vx, vy] = nodes[0];\n		const vscale = 0.031 + dy * 0.14;\n\n		const vbot = sqrt(vs * vs * vr * vr) / vs;\n		const vtop = -vbot;\n		for (let i = 0; i < 10; i++) {\n\n			const y = Math.random() * 0.95 * (vbot - vtop) - vbot + 0.05;\n			const bound = vs * (sqrt(sq(vs * vr) - sq(vs * y)) - 0.5) * vscale;\n			const foodX = Math.random() * 2 * bound - bound + vx;\n			const foodY = y * vscale + (vy - vbot * vscale);\n\n			if (foodX > 0 && foodX < 1 && foodY > 0 && foodY < 1)\n				if (oldNodesTree.nearest({ x: foodX, y: foodY }, 1, 0.000025).length == 0)\n					food.push([foodX, foodY]);\n		}\n	}\n\n	const nodeInfluences = {};\n	food.forEach(([foodX, foodY], foodIdx) => {\n		const nodeIdx = oldNodesTree.nearest({ x: foodX, y: foodY }, 1)[0][0].idx;\n		const foodVec = createVector(food[foodIdx][0], food[foodIdx][1]);\n		const nodeVec = createVector(nodes[nodeIdx][0], nodes[nodeIdx][1]);\n		const direction = p5.Vector.sub(foodVec, nodeVec).normalize();\n\n		if (nodeInfluences[nodeIdx])\n			nodeInfluences[nodeIdx].add(direction);\n		else\n			nodeInfluences[nodeIdx] = direction;\n	});\n	Object.keys(nodeInfluences).forEach(k => {\n		nodeInfluences[k].normalize()\n	});\n\n	const newNodes = [];\n	Object.keys(nodeInfluences).forEach(k => {\n		const node = nodes[k];\n		const influence = nodeInfluences[k]\n		const newNode = [node[0] + influence.x * veinStep, node[1] + influence.y * veinStep];\n		const newIdx = nodes.push(newNode) - 1;\n		newNodes.push(newNode);\n\n		const parentIdx = Number(k);\n		childlessNodes.add(newIdx);\n		const parentWasChildless = childlessNodes.delete(parentIdx);\n		edgeGraph.set(newIdx, parentIdx);\n		edges.set(`${newIdx}-${parentIdx}`, 1);\n\n		if (!parentWasChildless) {\n			let currentIdx = parentIdx;\n			while (currentIdx !== 0) {\n				const currentParentIdx = edgeGraph.get(currentIdx);\n				const edgeKey = `${currentIdx}-${currentParentIdx}`\n				const weight = edges.get(edgeKey);\n				edges.set(edgeKey, weight + 1);\n				currentIdx = currentParentIdx;\n				largest = Math.max(largest, weight);\n			}\n		}\n	});\n\n	// remove food if vein is in neighborhood\n	newNodes.forEach(([nodeX, nodeY]) => {\n		food.forEach(([foodX, foodY], idx) => {\n			const d = dist(foodX, foodY, nodeX, nodeY);\n			if (d < 0.025)\n				food.splice(idx, 1);\n		});\n	});\n\n	edges.forEach((weight, key) => {\n		const [a, b] = key.split('-').map(Number);\n		const [x1, y1] = nodes[a];\n		const n = sqrt(weight / largest);\n		strokeWeight(w(0.0015));\n		stroke(noise(frameCount * 0.01, y1, n * 5) * 100 + 150, 60 - 30 * n, 60 + 20 * n, 0.25);\n		ellipse(w(x1), h(y1), w(n * 0.1));\n	});\n}\n";
(0, $gPx2I.make)({
    setup: $075a852226c2c23c$export$de27182ff8187d6c,
    draw: $075a852226c2c23c$export$e529deb2bfd496dc
}, $af5179ab494d7e33$var$source);


//# sourceMappingURL=09.8868b5c3.js.map
